module.exports = __webpack_public_path__ + "img/appove-confirm.7c4c5427.svg";